import Vue from 'vue'

export default {
	state: {
		finance: null,
		allFinance: []
	},
	mutations: {
		loadAllFinance (state, payload) {
			state.allFinance = payload
		},
		setFinance (state, payload) {
			state.finance = payload
		},
		addFinance (state, payload) { 
			const index = state.allFinance.length
			Vue.set(state.allFinance, index, payload)  
		},
		changeFinance (state, payload) {
			const item = state.allFinance.find(com => com.id === payload.id)
			//console.log(item)
			const key = Object.keys(payload.value)[0]
			item[key] = payload.value[key]
			//Vue.set(state.allFinance, state.allFinance.indexOf(item), payload.value)  
		},
		deleteFinance (state, payload) {
			state.allFinance = state.allFinance.filter(item => item.id !== payload) 
		}
	},
	actions: {
		async fetchAllFinance ({commit}) {
			commit('clearError')
			commit('setLoading', true)

            const resArr = []
			
			try {
				const res = await Vue.$db.collection('financeSummary')
				.get()

				if (res) {
                    res.forEach(doc => {
                        const finance = doc.data()
                        finance.id = doc.id
                        resArr.push(finance) 
                    })
                   
                    commit('loadAllFinance', resArr)
				}
				//no channels
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async fetchFinance ({commit, getters}, payload=null) {
			commit('clearError')
			commit('setLoading', true)
			
			let company = ''
			const resArr = []

			if (payload) {
				company = payload
			}
			else {
				company = getters.company
			}
			//будет всего 1-н документ
			try {
				const res = await Vue.$db.collection('financeSummary')
				.where("team", "==", company)
				.get()

				let fin = {}
				if (!res.empty) {
					res.forEach(doc => {
						fin = doc.data()
						fin.id = doc.id
						resArr.push(fin)
					})
					commit('setFinance', resArr)
				}
				//no finance
				commit('setLoading', false)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async addFinance ({commit}, payload) {
			commit('clearError')
			commit('setLoading', true)
			
			try {
				const res = await Vue.$db.collection('financeSummary')
				.add(payload)
				
				payload.id = res.id
				
				commit('setLoading', false)
				commit('addFinance', payload)
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
		async changeFinance ({commit}, payload) {

			commit('clearError')
			commit('setLoading', true)

			const id = payload.id
			delete payload.id

			try {
				await Vue.$db.collection('financeSummary').doc(id)
				.set(payload, { merge: true })

				commit('setLoading', false)
				commit('changeFinance', { id: id, value: payload })
			}
			catch (error) {
				commit('setError', error.message)
				commit('setLoading', false)
				throw error
			}
		},
	},
	getters: {
		finance (state) {
			return state.finance //arr[{obj}] один объект в массиве
		},
		allFinance (state) {
			return state.allFinance
		}
		
	}
}